const DAY_DATES = { "1": "20261022", "2": "20261023", "3": "20261024" };

const parseTime = (t) => {
  const m = t.trim().toUpperCase().match(/(\d{1,2}):(\d{2})\s*(AM|PM)/);
  if (!m) return { h: 9, min: 0 };
  let h = +m[1] % 12;
  if (m[3] === "PM") h += 12;
  return { h, min: +m[2] };
};

const fmt = (dt) => dt.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

const esc = (s) => s.replace(/\\/g, "\\\\").replace(/,/g, "\\,").replace(/;/g, "\\;");

// Event times are IST (UTC+5:30); ICS stores UTC.
export function downloadIcs(e) {
  const { h, min } = parseTime(e.time);
  let startMin = h * 60 + min - 330;
  const base = DAY_DATES[e.day] || DAY_DATES["1"];
  const y = +base.slice(0, 4);
  const mo = +base.slice(4, 6);
  const d = +base.slice(6, 8);
  if (startMin < 0) startMin += 1440;
  const start = new Date(Date.UTC(y, mo - 1, d) + startMin * 60000);
  const end = new Date(start.getTime() + 90 * 60000);
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Doon91//Founders Day//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${e.id}@doon91`,
    `DTSTAMP:${fmt(new Date())}`,
    `DTSTART:${fmt(start)}`,
    `DTEND:${fmt(end)}`,
    `SUMMARY:${esc(e.title)} — The Doon School 91st Founder's Day`,
    `LOCATION:${esc(e.venue)}\\, The Doon School\\, Chandbagh\\, Dehradun`,
    `DESCRIPTION:${esc(e.desc)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `doon91-${e.id}.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
}
